import { 
  UPDATE_CART, 
  ADD_TO_CART, 
  REMOVE_FROM_CART, 
  CLEAR_CART 
} from '../actions/cartActions';

const initialState = {
  items: [],
  itemCount: 0
};

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_CART:
      return {
        ...state,
        items: action.payload,
        itemCount: action.payload.length
      };
      
    case ADD_TO_CART:
      return {
        ...state,
        items: action.payload,
        itemCount: action.payload.length
      };
      
    case REMOVE_FROM_CART:
      return {
        ...state,
        items: action.payload,
        itemCount: action.payload.length
      };
      
    case CLEAR_CART:
      return {
        ...state,
        items: [],
        itemCount: 0
      };
      
    default:
      return state;
  }
};

export default cartReducer;